module.exports = __webpack_public_path__ + "static/media/europe-map.f974b32c.svg";